import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import './Catalogos.css'

const Enlace = (props) => {
  return (
    <div className="catalogo">
      <Link to={props.link}>{props.label}</Link>
    </div>
  )
}

class Catalogos extends Component {

  componentDidMount() {
    // console.log(this.props);
  }

  render() {
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', padding: 20 }}>
          <Enlace link='/Catalogo/Clientes' label='Clientes' />
          <Enlace link='/Catalogo/OrigenesDestinos' label='Orígenes / destinos' />
          <Enlace link='/Catalogo/Lugares' label='Lugares' />
          <Enlace link='/Catalogo/Estados' label='Estados' />
          <Enlace link='/Catalogo/Ciudades' label='Ciudades' />
          <Enlace link='/Catalogo/Colonias' label='Colonias' />
          <Enlace link='/Catalogo/CodigosPostales' label='Códigos Postales' />
          <Enlace link='/Catalogo/Zonas' label='Zonas' />
          <Enlace link='/Catalogo/ZonasKm' label='Zonas KM / Horas Entrega' />
          <Enlace link='/Catalogo/Giros' label='Giros' />
          <Enlace link='/Catalogo/Sucursales' label='Sucursales' />
          <Enlace link='/Catalogo/Ejecutivos' label='Ejecutivos' />
          <Enlace link='/Catalogo/Bancos' label='Bancos' />
          <Enlace link='/Catalogo/CuentasBancarias' label='Cuentas Bancarias' />
          <Enlace link='/Catalogo/Transportistas' label='Transportistas' />
          <Enlace link='/Catalogo/UnidadesTransporte' label='Unidades de Transporte' />
          <Enlace link='/Catalogo/FormasPago' label='Formas de Pago' />
          <Enlace link='/Catalogo/MetodosPago' label='Metodos de Pago' />
          <Enlace link='/Catalogo/TiposCargos' label='Tipos de Cargos/Creditos' />
          <Enlace link='/Catalogo/Cargos' label='Cargos/Creditos' />
          <Enlace link='/Catalogo/CondicionesPagos' label='Condiciones de Pago' />
          <Enlace link='/Catalogo/GruposEmbalajes' label='Grupos de Embalaje' />
          <Enlace link='/Catalogo/Embalajes' label='Embalaje' />
          <Enlace link='/Catalogo/Redocumentaciones' label='Conceptos de Redocumentacion' />
          <Enlace link='/Catalogo/MotivosRechazo' label='Motivos de Rechazo' />
          <Enlace link='/Catalogo/PreciosCombustibles' label='Actualizacion Precio Combustible' />
          {/* <Enlace link='/Catalogo/' label='Catálogos' />
          <Enlace link='/Catalogo/' label='Catálogos' /> */}
        </div>
      </div>
    )
  }
}

export default withRouter(Catalogos)